<template>
<div >
	<Loader :show="loading || saving"></Loader>
	<b-modal id="carRequestDeliveryModal" :title="title" hide-footer no-close-on-backdrop no-close-on-esc @close="close">
		
        <b-form-group label="Empresa / concesionario que retira" >
            <b-form-input
                v-model="form.delivery_to_business"
                placeholder="Nombre de la empresa o concesionario que retira"
                :class="{'is-invalid':validation.hasError('form.delivery_to_business')}"
            ></b-form-input>
            <b-form-invalid-feedback>Ingrese el nombre o concesionario que retira</b-form-invalid-feedback>
        </b-form-group>
        
        <b-form-group label="Nombre transportista" >
            <b-form-input
                v-model="form.delivery_to_carrier"
                placeholder="Nombre transportista"
            ></b-form-input>
        </b-form-group>
    
        <b-form-group label="Fecha de retiro sugerida" >
            <date-picker 
                v-model="form.delivery_requested_date" 
                :class="{'is-invalid':validation.hasError('form.delivery_requested_date')}"
                type="date"
                value-type="YYYY-MM-DD" 
                format="DD-MM-YYYY"
                :disabled-date="disabledPeriodDate"
            ></date-picker>
            <!-- <b-form-input
                v-model="form.dua_dispatch"
                placeholder="Número de dua"
                :class="{'is-invalid':validation.hasError('form.dua_dispatch')}"
            ></b-form-input> -->
            <b-form-invalid-feedback>Ingrese la fecha que desea retirar los vehículos</b-form-invalid-feedback>
        </b-form-group>

        <div class="overflow-hidden mt-4">
            <b-button @click="close()" type="button" class="pull-left" size="sm" variant="light">Cancelar</b-button>
            <button type="submit" class="btn btn-primary pull-right" @click="save()" >Confirmar solicitud</button>
            
        </div>

	</b-modal>	
</div>
</template>

<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'carRequestDeliveryModal',
	components:{
		Loader
    },
    props:{
        carId:{
            required: true
        }
    },
    mixins: [mixins],
	data () {
		return {
			title: 'Solicitar entrega',
			show: false,
			loading:false,
			saving:false,
            id: null,
            form: {
				delivery_to_business: null,
				delivery_to_carrier: null,
                delivery_requested_date: null,
                cars:[]
			},
		}
    },
    validators: {
		'form.delivery_to_business': function (value) {
			return Validator.value(value).required();
		},
		'form.delivery_requested_date': function (value) {
			return Validator.value(value).required();
		},
		'form.cars': function (value) {
			return Validator.custom( () => {
				if(value.length<=0){
					return true
				}
			})
		},
	},
	methods: {
		open (id=null) {
			this.id = id
			if( id!==null ){
				this.loading = true
				this.title = 'Editar cliente'
            }
            this.form.cars.push(this.carId)
			this.showModal()
		},
		showModal() {
			this.show = true
			this.$bvModal.show('carRequestDeliveryModal')
		},
		close () {
			this.show = false
			this.form = {
                delivery_to_business: null,
				delivery_to_carrier: null,
                delivery_requested_date: null,
                cars:[]
            }
			this.$bvModal.hide('carRequestDeliveryModal')
        },
        disabledPeriodDate(date) {
			var yesterday = new Date()
			yesterday.setDate(yesterday.getDate())
			return date < yesterday
		},
        async save () {
			if(!this.saving && await this.checkValidation() ) {
				this.saving = true
				
				let dataInput = {
					delivery_to_business: 		this.form.delivery_to_business,
					delivery_to_carrier: 		this.form.delivery_to_carrier,
					delivery_requested_date: 	this.form.delivery_requested_date,
					cars: 						this.form.cars
				}
				this.create(dataInput)
			}
		},
		create (data) {
			this.$apollo.mutate({
				mutation: gql`mutation ( $data: RequestDeliveryInput! ){
					requestDelivery( data: $data) {
						id
					}
				}`,
				variables: {
					data
				}
			})
			.then(() => {
				this.$toast.success('Solicitud realizada correctamente')
                this.$emit('changed')
                this.close()
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})

		},
	}
}


</script>
